<template>
  <StepperHeader :current="1" />
  <RegisterLayout>
    <template #description>
      <h2>Tu seguridad nos importa</h2>
      <p>
        Recuerda que estos accesos te permitirán iniciar sesión y por tu seguridad debes seguir los
        parámetros para crear una contraseña segura.
      </p>

      <section class="drawing">
        <img src="@/app/register/assets/padlock.png" height="400" alt="padlock" />
      </section>
    </template>

    <template #form>
      <FormCard title="Crea tu contraseña" hide-img>
        <section class="container">
          <password-creator
            v-model:value="password"
            :ckeckterms="isckeckTerms"
            :ckecksubscribe="ischeckSubscribe"
            @checkbox-terms="handleTerms"
            @checkbox-subscribe="handleSubscribe"
            @setPassword="setPassword"
          />
          <div class="separator"></div>
          <a-row type="flex" justify="center">
            <a-col :span="24">
              <a-button
                class="button"
                type="primary"
                id="password-continue-btn"
                @click="handleClick"
                :disabled="password === ''"
              >
                Continuar
              </a-button>
            </a-col>
          </a-row>
        </section>
      </FormCard>
    </template>
  </RegisterLayout>
</template>

<script>
import { defineComponent } from "vue";
import PasswordCreator from "../../../shared/components/molecules/PasswordCreator.vue";
import StepperHeader from "../header/StepperHeader.vue";
import RegisterLayout from "../layout/RegisterLayout.vue";
import FormCard from "@/app/auth/components/atoms/FormCard.vue";
export default defineComponent({
  components: {
    PasswordCreator,
    StepperHeader,
    RegisterLayout,
    FormCard,
  },
  data() {
    return {
      isckeckTerms: false,
      ischeckSubscribe: false,
      password: "",
    };
  },

  created() {
    this.validateToken();
  },
  computed: {
    name() {
      return this.$store.getters["getTemporalUserName"];
    },
  },
  methods: {
    setPassword($event) {
      this.password = $event;
    },
    async validateToken() {
      try {
        const token = this.$route.params.token;
        await this.$store.dispatch("validateRegisterTemporalToken", token);
      } catch (error) {
        console.log(error.errors, 'error validate token');
        const errors = error.message?.errors?.[0] || error.errors?.[0];
        if (errors === "Token invalido") {
          this.$router.push("/token/invalid");
        } else if (errors === "Token expired") {
          this.$router.push("/token/expired");
        } else {
          this.$router.push("/token/expired");
        }
      }
    },
    handleClick() {
      if (!this.password) return;
      this.$store.dispatch("setRegistrationProgress", 3);
      this.$store.dispatch("setRegisterWorkspaceStep", 3);

      const data = {
        password: this.password,
        subscription: this.ischeckSubscribe,
      };
      this.$store.dispatch("addPropertiesToCustomer", data);
    },
    handleTerms($event) {
      this.isckeckTerms = $event;
    },
    handleSubscribe($event) {
      this.ischeckSubscribe = $event;
    },
  },
});
</script>

<style lang="sass" scoped>
.drawing
  // transform: rotate(6.64deg)
  width: 50%
  text-align: center

.container__info
  margin: 0 auto
  margin-top: 70px
  text-align: center

.name
  font-weight: 600
  font-size: 30px

.separator
  margin-bottom: 30px

.button
  width: 100%

.text--plan
  font-size: 20px
  font-weight: 400
  transform: rotate(-6.36deg)
  padding: 0 8vw
  color: $gray-8

.flex
  display: flex
  justify-content: space-between
</style>
